import { businessApi, type Business } from './api';

let inFlight: Promise<Business[]> | null = null;

/**
 * Coalesces concurrent calls to GET /businesses into a single request.
 * Sidebar and several pages each fetch the full business list on mount —
 * this collapses simultaneous calls into one network round-trip instead of
 * firing a duplicate request per consumer. Does not cache across time: once
 * the in-flight request resolves, the next call fetches fresh data.
 */
export function getBusinessList(): Promise<Business[]> {
  if (!inFlight) {
    inFlight = businessApi
      .getAll()
      .then((res) => res.data.data)
      .finally(() => {
        inFlight = null;
      });
  }
  return inFlight;
}
